/**
 * Resolve portal app URL. Mirrors apps/app's `getAdminUrl()` so the back-link
 * from admin lands on the correct environment instead of always bouncing the
 * user to production.
 *
 * Explicit env override wins (NEXT_PUBLIC_PORTAL_URL or VITE_PORTAL_URL).
 * Otherwise inferred from `window.location.hostname`:
 *   - admin.pontimed.local                  → portal.pontimed.local (Caddy)
 *   - localhost / 127.0.0.1                 → http://localhost:5173 (portal Vite dev
 *                                             server; :3100 is the frozen legacy app)
 *   - admin.<root>.pontimed.app             → portal.<root>.pontimed.app
 *   - admin.pontimed.app (prod)             → portal.pontimed.app
 */
export function getPortalUrl(): string {
  const explicit =
    (import.meta.env.NEXT_PUBLIC_PORTAL_URL as string | undefined) ??
    (import.meta.env.VITE_PORTAL_URL as string | undefined);
  if (explicit) return explicit;

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host.endsWith(".pontimed.local")) return "https://portal.pontimed.local";
    if (host === "localhost" || host === "127.0.0.1") return "http://localhost:5173";
    if (host.endsWith(".pontimed.app")) {
      const root = host.split(".").slice(-2).join(".");
      return `https://portal.${root}`;
    }
  }

  return "https://portal.pontimed.app";
}
